// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mTAw","content":"styles_content__1p6RT","tableWrap":"styles_tableWrap__2V2gy"};